export default __webpack_public_path__ + "static/media/Engine.b7f2b1a5.svg";